<template>
  <div class="overlay-full overlay-dnd" :style="{ display: showOverlay ? 'block' : '' }">
    <div v-if="!loadingActivity" class="overlay-content">
      <p class="title">Do not disturb</p>
      <p>To continue working you must be active</p>
      <custom-button
        variant="primary"
        custom-class="im-active"
        content="I'm active"
        :is-disabled="loadingActivity"
        @onClick="setAsActive('online')"
      />
    </div>
    <div v-else class="overlay-content">
      <p class="title">Updating your activity status..</p>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";
import { Activity } from "../../services/api/user-activity";
import CustomButton from "../Button.vue";

export default {
  name: "OverlayDND",
  components: {
    CustomButton
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showOverlay: this.show
    };
  },
  computed: {
    ...mapState("activity", ["loadingActivity"]),
    ...mapGetters("activity", ["currentActivity"])
  },
  methods: {
    ...mapMutations("activity", ["SET_LOADING_ACTIVITY"]),

    async setAsActive(status) {
      this.SET_LOADING_ACTIVITY(true);

      try {
        await Activity.changeStatus(status);
      } catch (error) {
        console.error('Error changing status:', error);
      } finally {
        // Handle potential race condition
        setTimeout(() => {
          this.SET_LOADING_ACTIVITY(false);
        }, 1000);
      }
    }
  },
  watch: {
    currentActivity: function(value) {
      this.showOverlay = value.status === "dnd";
    }
  }
};
</script>
